import { colors } from "@mui/material";

export const errorIconStyle = {
  color: colors["red"]["A400"],
  marginLeft: 10,
  cursor: "pointer",
  alignSelf: "center",
};
